var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCercle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2330 4869 c-126 -13 -341 -57 -464 -96 -497 -157 -928 -478 -1225 -913 -444 -648 -523 -1488 -210 -2217 111 -260 258 -479 464 -692 391 -403 893 -646 1449 -700 904 -88 1791 379 2240 1179 454 810 382 1793 -188 2545 -74 98 -255 286 -357 370 -94 80 -268 197 -380 258 -389 212 -882 311 -1329 266z m431 -309 c460 -47 891 -252 1218 -580 329 -329 534 -760 581 -1219 65 -645 -193 -1294 -683 -1716 -811 -700 -1998 -652 -2752 111 -364 367 -575 883 -575 1404 0 599 276 1179 740 1556 412 335 948 497 1471 444z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCercle);
export default __webpack_public_path__ + "static/media/cercle.dcdad200.svg";
export { ForwardRef as ReactComponent };